import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6a8f0a6b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6a8f0a6b&lang=less&scoped=true&"
import style1 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8f0a6b",
  null
  
)

export default component.exports